export const makeSeriesLabel = (rawId: string): string => {
  if (!rawId.startsWith('CMVOL_')) return rawId;
  const parts = rawId.split('_');
  if (parts.length < 4) return rawId;

  const maybeQuote = parts[parts.length - 1];
  const maybeBase = parts[parts.length - 2];
  const QUOTE_TOKENS = ['USDC', 'USD', 'USDT'];

  let endIndexExclusive = parts.length - 1;
  if (QUOTE_TOKENS.includes(maybeQuote) && maybeBase.length <= 6) {
    endIndexExclusive = parts.length - 2;
  }

  const labelParts = parts.slice(1, endIndexExclusive);
  return labelParts.join(' ');
};
